// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/user-logged/user-logged.scss
// module id = 534
// module chunks = 0